import React from 'react';

import {
  H1,
  Page,
  PageBody,
  PageHead,
  PageTitle,
  Panel,
} from 'next/components/ui';
import styled from 'styled-components';
import FlowTable from 'components/Priorities/FlowTable';
import { selectAccountFeature } from 'reducers/account/features';
import { FLOW_FREQUENCY } from 'constants/features';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FrequencyLimitsModalManager from './FrequencyLimitsModalManager';

const FrequencyLimitWrapper = styled(Panel)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Priorities = ({ hasFrequency }) => (
  <Page>
    <PageHead>
      <PageTitle>
        <H1>Flow priority</H1>
      </PageTitle>
    </PageHead>
    <PageBody>
      {hasFrequency && (
        <FrequencyLimitWrapper>
          You can limit how often users can see a Flow or NPS survey.
          <FrequencyLimitsModalManager />
        </FrequencyLimitWrapper>
      )}
      <FlowTable />
    </PageBody>
  </Page>
);

Priorities.propTypes = {
  hasFrequency: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    hasFrequency: selectAccountFeature(state, FLOW_FREQUENCY),
  };
}

export default connect(mapStateToProps)(Priorities);
